import React from "react";

const PublicInvoiceContext = React.createContext();
PublicInvoiceContext.displayName = "PublicInvoiceContext"

export default PublicInvoiceContext;